import TemplateView from '../../../TemplateView'
import {connect} from '../../../redux/utils'
import SimpleListMenuButton from '../../../SimpleListMenuButton'
import Button from '../../../components/Button'
import messageResource from '../../../messageResource'
import {createYearsListForSelector} from '../utils'
import {WORK_SCHEDULE_YEAR_START} from '../constants'
import {bindActionCreators} from 'redux'
import {loadCountries, loadData, selectYear} from '../actions'
import {geSelectedYear, isEditing} from '../selectors'
import LoadingSpinner from '../../../components/LoadingSpinner'
import {CURRENT_PRODUCT, LicenseInfo, Product} from 'constants'
import {getInstance as importHolidaysDialog} from './ImportHolidaysDialog'

class CalendarHeader extends TemplateView {
    constructor({
        loadData,
        setSelectedYear,
        onImportButtonClick = () => {},
        onHolidayListButtonClick = () => {}
    }) {
        super()

        this.actions = {
            onImportButtonClick,
            onHolidayListButtonClick,
            loadData,
            setSelectedYear,
        }

        this.state = {
            selectedYear: '',
            editing: false,
            needShowImportDialog: false,
        }

        this.onStatePropertyChanged('selectedYear', (selectedYear) => {
            this.yearSelector.setSelectedItem({year: selectedYear})
            this.importButton.setState({disabled: selectedYear < window.currentUserTime().clearTime().getFullYear()})
        })

        this.onStatePropertyChanged('editing', editing => {
            this.editingSpinner.setState({show: editing})
        })
    }

    templateHtml() {
        return '<div class="headerContent">' +
               '    <div class="title">' +
               '        <div class="label"><%=headerYearSelectorTitle%></div>' +
               '        <div class="list"></div>' +
               '        <span class="sharedSettingsImage" title="<%=sharedSettingsImageTitle%>"/>' +
               '        <div class="spinnerContainer"/>' +
               '    </div>' +
               '    <div class="legendButtonContainer">' +
               '        <div class="legend">' +
               '            <div class="legendItem workingDay">' +
               '                <div class="marker"></div>' +
               '                <div class="label"><%=workingDayLegendTitle%></div>' +
               '            </div>' +
               '            <div class="legendItem nonworkingDay">' +
               '                <div class="marker"></div>' +
               '                <div class="label"><%=nonworkingDayLegendTitle%></div>' +
               '            </div>' +
               '            <div class="legendItem holiday">' +
               '                <div class="marker"></div>' +
               '                <div class="label"><%=holidayLegendTitle%></div>' +
               '            </div>' +
               '        </div>' +
               '        <div class="separator"></div>' +
               '        <div class="holidayListButton"></div>' +
               '        <div class="importHolidaysButton"></div>' +
               '    </div>' +
               '</div>'
    }

    messageKeys() {
        return {
            headerYearSelectorTitle: 'work_schedule.page_title_selector',
            workingDayLegendTitle: 'work_schedule.header.legend.working_day',
            nonworkingDayLegendTitle: 'work_schedule.header.legend.nonworking_day',
            holidayLegendTitle: 'work_schedule.header.legend.holiday',
            sharedSettingsImageTitle: 'general_settings.shared_settings',
        }
    }

    afterRender() {
        this.yearSelector = new SimpleListMenuButton({
            itemHtmlCallback: item => item.year,
            onSelect: (item) => {
                this.actions.setSelectedYear(item.year)
                this.actions.loadData(item.year)
            },
            menuPositionParams: {
                my: "right top",
                at: "right bottom",
            },
            itemHeight: 30,
        }).init(this.find('.list'))

        this.editingSpinner = new LoadingSpinner().init(this.find('.spinnerContainer'))

        const currentYear = new Date().getFullYear()
        this.yearSelector.setItems(
            createYearsListForSelector(WORK_SCHEDULE_YEAR_START, currentYear + 1), {year: currentYear})

        new Button({
            additionalClass: 'list',
            label: messageResource.getMessage('work_schedule.header.holiday_list_button'),
            onClickCb: () => this.actions.onHolidayListButtonClick()
        }).init(this.find('.holidayListButton'))

        this.importButton = new Button({
            additionalClass: 'import',
            label: messageResource.getMessage('work_schedule.header.import_holidays_button'),
            onClickCb: () => this._showImportDialog(),
            withDisableTooltip: true,
            tooltipAdditionalClass: 'importHolidaysButtonDisabledTooltip',
        }).init(this.find('.importHolidaysButton'))
        this.importButton.setState({disableTooltipText: messageResource.getMessage('work_schedule.header.import_holidays_button_disabled_tooltip')})

        this.find('.sharedSettingsImage').toggle(CURRENT_PRODUCT === Product.actiTIME ? LicenseInfo.isApActive : LicenseInfo.isAtActive)
    }

    _showImportDialog() {
        importHolidaysDialog().showAt(
            this.importButton.getEl(),
            {
                my: 'right top',
                at: 'right bottom',
            }
        )
        this.actions.onImportButtonClick()
    }
}

export default connect(
    (state) => ({
        selectedYear: geSelectedYear(state),
        editing: isEditing(state),
    }),
    (dispatch) => ({
        loadData: bindActionCreators(loadData, dispatch),
        setSelectedYear: bindActionCreators(selectYear, dispatch),
        onImportButtonClick: bindActionCreators(loadCountries, dispatch),
    })
)(CalendarHeader)



// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/components/CalendarHeader.js